module.exports = __webpack_public_path__ + "static/media/advantage-cswap-x-midnight-3.175d485b.png";